import { Link, Stack, Typography } from "@mui/material";
import CustomButton from "components/CustomButton";
import CustomDialog from "components/CustomDialog";
import CustomDataGrid from "components/customDataGrid";
import { DATE_FORMAT } from "config/const";
import { currencyFormat, openPdfInNewTab } from "config/functions";
import { YESH_INVOICE_DOCUMENT_TYPE } from "containers/dashboard/const";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import moment from "moment";

const DocumentsDetails = ({ data, setData, dialogTitle }) => {
    const { bt } = useBizTypeTranslation();
    const onClose = () => { setData(null) };



    return (
        <CustomDialog width={600} open={data ? true : false} onClose={onClose} title={dialogTitle}>
            <Stack>
                <CustomDataGrid
                    maxHeight={450}
                    minHeight={450}
                    borderRadius="10px 10px 10px 10px"
                    columns={[
                        {
                            field: "DocumentNumber",
                            headerName: bt("DOCUMENT_NUMBER"),
                            filterable: false,
                            width: 80,
                        },
                        {
                            field: "customerName",
                            headerName: bt("BIZ_NAME"),
                            filterable: true,
                            width: 150,
                        },
                        {
                            field: "price",
                            headerName: bt("PAYMENT_AMOUNT"),
                            filterable: false,
                            width: 100,
                            renderCell: (params) => {
                                return (
                                    <Stack height="100%" direction="row" alignItems="center" spacing={0.5}>
                                        <Typography
                                            fontSize={14}
                                            color={
                                                params?.row?.documentType === YESH_INVOICE_DOCUMENT_TYPE.CREDIT_NOTE ||
                                                    params?.row?.priceValue < 0
                                                    ? "error.text"
                                                    : "success.main"
                                            }
                                        >
                                            {params?.value}
                                        </Typography>
                                    </Stack>

                                )
                            }

                        },
                        // {
                        //     field: "download",
                        //     headerName: bt("DOWNLOAD_DOCUMENT"),
                        //     filterable: false,
                        //     width: 90,
                        //     renderCell: (params) => {
                        //         return (<a href={params?.value} target="_blank">{bt("DOWNLOAD")}</a>)
                        //     }
                        // },
                        {
                            field: "show",
                            headerName: bt("SHOW_DOCUMENT"),
                            filterable: false,
                            width: 100,
                            renderCell: (params) => {
                                return (
                                    <Link
                                        fontSize={14}
                                        component="button"
                                        underline="hover"
                                        onClick={() => openPdfInNewTab(params?.row?.download)}
                                    >
                                        {bt("SHOW")}
                                    </Link>
                                )
                            }
                        },
                        {
                            field: "created",
                            headerName: bt("CREATED"),
                            filterable: true,
                            width: 120,
                        },
                    ]}
                    list={data?.map((item) => ({
                        ...item,
                        download: item?.pdfUrl,
                        priceValue: item?.price,
                        price: item?.price ? currencyFormat(Math.abs(item?.price)) : "",
                        created: item?.Date ? moment(item?.Date, "DD-MM-YYYY").format(DATE_FORMAT) : "",
                        documentType: item?.DocumentType || item?.documentType,
                    })) ?? []
                    }
                />

            </Stack>
        </CustomDialog>
    );
};
export default DocumentsDetails;